//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Gateway.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Area",1,0],[0,"AssignRolledUpAttribute",1,0],[0,"Density",1,0],[0,"DeriveOption",1,1],[0,"GravityCenterX",1,0],[0,"GravityCenterY",1,0],[0,"GravityCenterZ",1,0],[0,"InertiaXX",1,0],[0,"InertiaXY",1,0],[0,"InertiaXZ",1,0],[0,"InertiaYY",1,0],[0,"InertiaYZ",1,0],[0,"InertiaZZ",1,0],[0,"Mass",1,0],[0,"MassType",1,0],[1,"Objects",0,"SelectNXObjectList",0],[0,"Volume",1,0]],[[[],"GetMassValues",{},0,0],[["valueType"],"UpdateMassValueSource",{},1,0],[["valueType"],"UpdateDensityValueSource",{},1,0],[["valueType"],"UpdateVolumeValueSource",{},1,0]],[]];
SPLM.Gateway.MassValueBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Gateway.MassValueBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Gateway.MassValueBuilder.MassTypes = Object.freeze({
    "Unset" : "Unset", "MassOnly" : "MassOnly", "DensityOnly" : "DensityOnly", "VolumeOnly" : "VolumeOnly", "DensityMass" : "DensityMass", "DensityVolume" : "DensityVolume", "MassVolume" : "MassVolume", "AssertAll" : "AssertAll"});

SPLM.Gateway.MassValueBuilder.ValueSourceType = Object.freeze({
    "Unset" : "Unset", "Computed" : "Computed", "Asserted" : "Asserted", "UserDefined1" : "UserDefined1", "UserDefined2" : "UserDefined2", "UserDefined3" : "UserDefined3", "UserDefined4" : "UserDefined4", "ComputedCoated" : "ComputedCoated", "Actual" : "Actual", "Estimated" : "Estimated"});

export default SPLM;